module.exports = __webpack_public_path__ + "img/ok-icon.2d9fadad.svg";